module.exports = __webpack_public_path__ + "files/5acb381b12b66ca6afef5d9edb948672.woff";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/katex/dist/fonts/KaTeX_Script-Regular.woff
// module id = 1671
// module chunks = 60